import { useState } from 'react';
const T = { bg: '#f0f5e8', cream: '#fffef0', greenDk: '#1b5e20', greenPale: '#e8f5e9', maroon: '#6d1b1b', orange: '#e65100', border: '#c8e6c9', header: 'linear-gradient(135deg, #090b72, #1a237e)', saffron: '#fff8e1' };

const NumerologyPage = () => {
  const [name, setName] = useState('');
  const [dob, setDob] = useState('');
  const [result, setResult] = useState(null);

  const tamilNums = { 'அ':1,'ஆ':1,'இ':1,'ஈ':1,'உ':1,'ஊ':1,'எ':1,'ஏ':1,'ஐ':1,'ஒ':1,'ஓ':1,'ஔ':1,
    'க':2,'ங':2,'ச':3,'ஞ':3,'ட':4,'ண':4,'த':5,'ந':5,'ப':6,'ம':6,'ய':7,'ர':7,'ல':8,'வ':8,'ழ':9,'ள':9,'ற':9,'ன':9 };
  const engNums = { A:1,B:2,C:3,D:4,E:5,F:8,G:3,H:5,I:1,J:1,K:2,L:3,M:4,N:5,O:7,P:8,Q:1,R:2,S:3,T:4,U:6,V:6,W:6,X:5,Y:1,Z:7 };

  const reduce = (n) => { while(n > 9 && n !== 11 && n !== 22) { n = String(n).split('').reduce((a,b)=>a+parseInt(b),0); } return n; };

  const calc = (e) => {
    e.preventDefault();
    if (!name.trim() || !dob) return;
    const parts = dob.split('-');
    const lifeNum = reduce(parts.reduce((a,p) => a + p.split('').reduce((s,c)=>s+parseInt(c),0), 0));
    const birthNum = reduce(parseInt(parts[2]));
    let nameNum = 0;
    for (const c of name.toUpperCase()) { if (engNums[c]) nameNum += engNums[c]; if (tamilNums[c]) nameNum += tamilNums[c]; }
    nameNum = reduce(nameNum);
    setResult({ lifeNum, birthNum, nameNum });
  };

  const meanings = {
    1: 'தலைமை, சுதந்திரம், முன்னோடி', 2: 'ஒத்துழைப்பு, சமநிலை, இணக்கம்',
    3: 'படைப்பாற்றல், வெளிப்பாடு, மகிழ்ச்சி', 4: 'ஸ்திரத்தன்மை, கடின உழைப்பு',
    5: 'சுதந்திரம், சாகசம், மாற்றம்', 6: 'அன்பு, குடும்பம், பொறுப்பு',
    7: 'ஆன்மீகம், ஞானம், ஆராய்ச்சி', 8: 'செல்வம், அதிகாரம், வெற்றி',
    9: 'மனிதாபிமானம், கருணை, முழுமை',
  };

  return (
    <div style={{ background: T.bg, minHeight: '80vh', padding: '10px' }}>
      
      <div style={{ background: T.header, padding: '12px', borderRadius: '10px', textAlign: 'center', marginBottom: '10px' }}>
        <h1 style={{ color: '#fff', margin: 0, fontSize: '1rem', fontWeight: 900 }}>🔢 எண்கணிதம்</h1>
        <div style={{ color: '#c8e6c9', fontSize: '0.7rem' }}>Numerology Calculator</div>
      </div>
      <form onSubmit={calc} style={{ background: T.cream, padding: '12px', borderRadius: '10px', marginBottom: '10px', border: '1px solid ' + T.border }}>
        <div style={{ marginBottom: '8px' }}>
          <label style={{ fontSize: '0.75rem', fontWeight: 700, color: T.greenDk }}>பெயர் / Name</label>
          <input value={name} onChange={e=>setName(e.target.value)} style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ccc', marginTop: '2px' }} placeholder="Enter name" />
        </div>
        <div style={{ marginBottom: '8px' }}>
          <label style={{ fontSize: '0.75rem', fontWeight: 700, color: T.greenDk }}>பிறந்த தேதி / DOB</label>
          <input type="date" value={dob} onChange={e=>setDob(e.target.value)} style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ccc', marginTop: '2px' }} />
        </div>
        <button type="submit" style={{ width: '100%', padding: '10px', background: T.greenDk, color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 800, cursor: 'pointer', fontSize: '0.85rem' }}>கணக்கிடு / Calculate</button>
      </form>
      {result && (
        <div style={{ display: 'grid', gap: '8px' }}>
          {[['🔮 ஜீவ எண்', result.lifeNum], ['🎂 பிறவி எண்', result.birthNum], ['✍️ பெயர் எண்', result.nameNum]].map(([label, num], i) => (
            <div key={i} style={{ background: T.cream, padding: '10px', borderRadius: '8px', border: '1px solid ' + T.border }}>
              <div style={{ fontWeight: 800, color: T.greenDk, fontSize: '0.85rem' }}>{label}: <span style={{ color: T.orange, fontSize: '1.2rem' }}>{num}</span></div>
              <div style={{ fontSize: '0.7rem', color: T.maroon, marginTop: '4px' }}>{meanings[num] || ''}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default NumerologyPage;